import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getAllowedOrderEditTypes = {
  name: "getAllowedOrderEditTypes" as const,
  input: z.object({
    orderId: zExt.objectId(),
  }),
  output: z.object({
    cancelOrder: z.boolean(),
    changeAddress: z.boolean(),
    updateOrder: z.boolean(),
    addOrderDiscount: z.boolean(),
    addOrderGiftNote: z.boolean(),
  }),
};
